import { render, staticRenderFns } from "./taobao_shangou_qun.vue?vue&type=template&id=dad18ee0&scoped=true&"
import script from "./taobao_shangou_qun.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou_qun.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou_qun.vue?vue&type=style&index=0&id=dad18ee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad18ee0",
  null
  
)

export default component.exports